import { Accordion, Menu } from "@mantine/core"
import React, { MouseEvent, ReactNode } from "react"

import { Icon } from "@/components"
import { useStyles } from "@/components/AccordionWithOptions/AccordionWithOptions.styles"
import { TitleInput } from "@/components/Controlled"

interface Options {
    text: string
    onClick: () => void
    showIf?: boolean
    icon?: string
    disabled?: boolean
    title?: string
}

interface Props {
    children: ReactNode
    title: string
    titleName: string
    options: Options[]
    itemId: string
}

export const AccordionWithOptions = ({ children, title, titleName, options, itemId }: Props) => {
    const { classes } = useStyles()

    const handleStopPropagation = (e: MouseEvent<HTMLElement>, callback?: () => void) => {
        e.stopPropagation()
        if (callback) callback()
    }
    return (
        <Accordion.Item value={itemId} className={classes.item}>
            <Accordion.Control className={classes.titleContent}>
                <TitleInput name={titleName} defaultValue={title} blankValue={title} className={classes.title} />
                <Menu>
                    <Menu.Target>
                        <Icon onClick={handleStopPropagation} icon="ellipsis-v" />
                    </Menu.Target>
                    <Menu.Dropdown onClick={handleStopPropagation}>
                        {options.map((option, index) => (
                            <Menu.Item
                                key={`${option.text}-${index}`}
                                onClick={(e) => handleStopPropagation(e, option.onClick)}
                                disabled={option.disabled}
                            >
                                <Icon size="sm" icon={option.icon} className={classes.iconItem} />
                                {option.text}
                            </Menu.Item>
                        ))}
                    </Menu.Dropdown>
                </Menu>
            </Accordion.Control>
            <Accordion.Panel className={classes.innerContent}>{children}</Accordion.Panel>
        </Accordion.Item>
    )
}
